import React, { useEffect, useRef, useState } from "react";
import RptStyle from "../Style/Reports.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { CalendarFilter } from "../../../Components/Search/Search";
import { ActionButtons } from "../../../../global/components/Buttons/buttons";
import { MdHistory } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { GetReportTriggerHistory } from "../../../../../utils/redux/Report/ReportSlice";

const todaysDate = new Date();
const last30Days = new Date(new Date().setDate(todaysDate.getDate() - 30));

export default function GenerateReports() {
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dateRange, setDateRange] = useState({
    from: last30Days,
    to: todaysDate,
  });
  const iframeEl = useRef();
  const siteUrl =
    "https://reports.nlpcpfa.com:8444/public/dashboard/f02414b2-a234-4d5e-94af-2fc69d3dc2a1?gender=";

  useEffect(() => {
    dispatch(
      GetReportTriggerHistory({
        PageSize: pageSize,
        CurrentPage: currentPage,
        StartDate: dateRange.from?.toISOString(),
        EndDate: dateRange.to?.toISOString(),
      })
    );
  }, [pageSize, currentPage, dispatch, dateRange.from, dateRange.to]);

  const getFilteredData = () => {
    dispatch(
      GetReportTriggerHistory({
        PageSize: pageSize,
        CurrentPage: currentPage,
        StartDate: dateRange.from?.toISOString(),
        EndDate: dateRange.to?.toISOString(),
      })
    );
  };

  return (
    <RouteLayout title="Reports / Generate Reports">
      <div className={RptStyle.head}>
        <div className={RptStyle.head_text}>Report Trigger History</div>
      </div>
      <PageStyle>
        <div className={RptStyle.report_filters}>
          <CalendarFilter
            name="Date Range"
            date={dateRange}
            onChange={(dateRange) => {
              setDateRange(dateRange);
            }}
          />
          <ActionButtons
            className={RptStyle.report_filters_button}
            onClick={getFilteredData}
          >
            <MdHistory />
            Get Trigger History
          </ActionButtons>
        </div>
      </PageStyle>
      <PageStyle>
        <iframe
          ref={iframeEl}
          src={`${siteUrl}`}
          title={"ggggg"}
          className={""}
          frameBorder={0}
          width={800}
          height={600}
          allowTransparency
          style={{
            border: "none",
            width: "100%",
            height: 650,
          }}
        />
      </PageStyle>
    </RouteLayout>
  );
}
